// Transforms a parsed row + column mapping into a normalized lead payload.
// Applies: name -> title case, cpf/phone -> digits only, email -> trim+lowercase,
// interest -> joined with ' | ' separator.

const INTEREST_SEPARATOR = ' | ';

export default function buildLeadPayload(row, mapping, rowNumber) {
  const pick = (idx) => (idx == null ? '' : String(row?.[idx] ?? '').trim());

  const name = toTitleCase(pick(mapping.name));
  const cpf = pick(mapping.cpf).replace(/\D/g, '');
  const email = pick(mapping.email).toLowerCase();
  const phone = pick(mapping.phone).replace(/\D/g, '');

  const interestValues = (mapping.interest || [])
    .map(idx => pick(idx))
    .filter(Boolean);
  const interest = interestValues.join(INTEREST_SEPARATOR);

  return { name, cpf, email, phone, interest, _row: rowNumber };
}

function toTitleCase(str) {
  if (!str) return '';
  return str
    .toLowerCase()
    .replace(/(?:^|\s)\S/g, c => c.toUpperCase());
}
